import * as PropTypes from "prop-types";
import {WIZARD_GROUP_TYPES} from "../WizardSetup/WizardItem/wizardItemInterface";

export const DISCOUNT_MAIN_TYPES = {
  custom: "custom",
  freeFill: "freeFill",
  lowesIME: "lowesIME",
  subTotal: "subTotal",
  nested: "nested",
  finance: "finance",
  deposit: "deposit",
};

export const DISCOUNT_TYPES = {
  price: "Price",
  percent: "Percent"
};

export const DISCOUNT_MODES = {
  and: "And",
  or: "Or"
};

export const DISCOUNT_SECTION_TYPES = {
  default: "default",
  finance: "finance"
};

export const discountInterFace = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  uuId: PropTypes.string, // new discounts
  discountType: PropTypes.oneOf(Object.keys(DISCOUNT_MAIN_TYPES)),
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([DISCOUNT_TYPES.price, DISCOUNT_TYPES.percent]).isRequired,
  mode: PropTypes.oneOf([DISCOUNT_MODES.and, DISCOUNT_MODES.or]).isRequired,
  amount: PropTypes.number.isRequired,
  isRidged: PropTypes.bool.isRequired,
  isSubTotal: PropTypes.bool,
  nestedParent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  financePercentage: PropTypes.number,
  financeMonths: PropTypes.number,
  financeSalesPercentage: PropTypes.number,
  financeOptions: PropTypes.string, // "['uuId', 'uuId', 'uuId']" JSON
  multiSelections: PropTypes.bool,
  approveOptions: PropTypes.string, // "['Some Name', 'Another Name']"
  wizardOptions: PropTypes.string, // "{showInAllRooms: true}"
};

export const defaultDiscount = {
  id: 0,
  order: 0,
  name: "Special offer",
  enabled: true,
  type: DISCOUNT_TYPES.price,
  mode: DISCOUNT_MODES.and,
  amount: 0,
  isRidged: false,
  isSubTotal: false
};

export const discountSectionsInterface = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  wizardLogic: PropTypes.string, // "{index: 1, }"
  discounts: PropTypes.arrayOf(PropTypes.shape(discountInterFace))
};

export const workSheetObjectInterface = {
  index: PropTypes.number.isRequired,
  discountSections: PropTypes.array.isRequired,
};

export const discountWizardLogicInterface = {
  index: PropTypes.number.isRequired,
  displayOptions: PropTypes.arrayOf(PropTypes.shape(discountWizardLogicDisplayOptionsInterface)),
};

export const discountWizardLogicDisplayOptionsInterface = {
  id: PropTypes.string,
  forVisualizer: PropTypes.string,
  forWizardId: PropTypes.number,
  forWizardHashId: PropTypes.string,
  forWizardName: PropTypes.string,
  forWizardGroupTitle: PropTypes.string,
  forWizardGroupId: PropTypes.string,
  forWizardGroupName: PropTypes.string,
};

export const defaultDiscountSection = {
  id: 0,
  order: 0,
  type: DISCOUNT_SECTION_TYPES.default,
  name: "Offers",
  discounts: []
};

export const DISCOUNT_FINANCE_CELLS = {
  financePercentage: "Finance Percentage",
  financeMonths: "Months",
  financeSalesPercentage: "Sales Person Percentage",
}
